import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var PendingOrderRes;
export const PendingOrderTodo = createAsyncThunk('PendingOrder', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'cart_item_list',
            headers: { "Content-Type": "application/json" },
            data: {
                "hod_id": type === 'admin' ? '' : type === 'teacher' ? localStorage.getItem('hod') : '',
                'user_id': type === 'student' ? localStorage.getItem('user_id') : '',
                "item_status": "pending"
            }
        })
        return PendingOrderRes = res.data

    } catch (error) {
        return PendingOrderRes = error.response.data
    }
});

const PendingOrderSlice = createSlice({
    name: 'PendingOrder',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(PendingOrderTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(PendingOrderTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default PendingOrderSlice.reducer; 